/* eslint-disable no-unused-vars */
import React, {Component} from 'react';
import {render} from 'react-dom';
import MapGL, { FlyToInterpolator } from 'react-map-gl';
import {json as requestJson} from 'd3-request';
import * as d3 from 'd3-ease'
import {fromJS} from 'immutable';
import WebMercatorViewport from 'viewport-mercator-project';
import _ from 'lodash';
import {
  firebaseConnect,
  isLoaded,
  isEmpty
} from 'react-redux-firebase';
import { Loader } from 'semantic-ui-react';
import UserProfile from './user-profile';
import SessionsList from './sessions-list';
import Buttons from './buttons';
import Notifications from './notifications';
import SideBar from './side-bar';
// import NavBar from './nav-bar';

import { getFeaturesFromGeoFire } from './utils';
import { getLineFeaturesFromSession, firebaseListener } from './firebase';
import {defaultMapStyle, sessionsLayer, linesLayer, clustersLayer, clustersCountLayer} from './map-style.js';

export const MARGIN_LEFT = 30;

export default class App extends Component {

  state = {
    updateState: (newState) => this.setState(newState),
    updateStatee: (newState) => {
      console.log('updateState',newState)
      this.setState({cluster: false})
    },
    // mapStyle: 'mapbox://styles/kevaid/cjmf20v7hl6yz2splnkxzc79f', // v1
    // mapStyle: 'mapbox://styles/kevaid/cjmf35tow11wr2rnvsw5jyp1o', // v2
    mapStyle: '',
    loading: true,
    viewport: {
      latitude: 39.1098747253418,
      longitude: -84.50493621826172,
      zoom: 3,
      bearing: 0,
      pitch: 0,
      width: 500,
      height: 500,
      maxZoom: 15,
      minZoom: 1,
    },
    features: [],
    activeFeatureId: null,
    selectedUser: null,
    notifications: [],
    loadingUserSessions: false,
    sessions: {},
    showRenderButton: false,
    loadingLines: false,
    renderedSessions: [],
    cluster: true,
    activeSidebar: 'home',
  }

  componentDidMount() {
    window.addEventListener('resize', this._resize);
    this._resize();
    if(this.state.loading && isLoaded(this.props.sessions))
      this._loadData();
  }

  componentDidUpdate(prevProps) {
    const { loading } = this.state;
    if(loading && isLoaded(this.props.sessions))
      this._loadData();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._resize);
  }

  // -------------------------------------
  // Data Functions
  // -------------------------------------

  _loadData = () => {
    // load flattened session data
    const { sessions } = this.props;
    var features = _.values(sessions); // convert to array
    this._initializeMapStyle(features);
    this.setState({sessions});
  }

  // -------------------------------------
  // Initialize Map
  // -------------------------------------

  _initializeMapStyle = (features) => {

    const clusteredSessions = {
      type: 'geojson',
      data: {
        "type": "FeatureCollection",
        "features" : fromJS(features),
      },
      cluster: true,
      clusterMaxZoom: 11, // Max zoom to cluster points on
      clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
    };
    const unclustedSessions = {
      type: 'geojson',
      data: {
        "type": "FeatureCollection",
        "features" : fromJS(features),
      }
    };

    const drawings = {
      type: 'geojson',
      data: {
        "type": "FeatureCollection",
        "features" : [],
      }
    };

    var mapStyle = defaultMapStyle
      .setIn(['sources', 'drawings'], fromJS(drawings))
      .setIn(['sources', 'selected-session'], fromJS(drawings))
      .setIn(['sources', 'sessions'], fromJS(unclustedSessions))
      .setIn(['sources', 'clustered-sessions'], fromJS(clusteredSessions))
      .set('layers', defaultMapStyle.get('layers').push(sessionsLayer))

    mapStyle = mapStyle
      .set('layers', mapStyle.get('layers').push(clustersLayer))

    mapStyle = mapStyle
      .set('layers', mapStyle.get('layers').push(clustersCountLayer))

    mapStyle = mapStyle
      .set('layers', mapStyle.get('layers').push(linesLayer))

    this.setState({
      mapStyle,
      loading: false,
      // sessions,
      features,
    });
  }


  _onMapLoad = event => {
    this.map = this.mapRef.getMap()
    this._onMapMove();
    this._toggleClusterSetting(); // set this to the default
    // this._testDraw(this.state.features[9])
    event.target.on('move', this._onMapMove );
  }

  // -------------------------------------
  // Settings Functions
  // -------------------------------------
  _toggleClusterSetting = () => {
    this.map.setLayoutProperty("clusters", "visibility", !this.state.cluster ? "visible" : "none");
    this.map.setLayoutProperty("cluster-count", "visibility", !this.state.cluster ? "visible" : "none");
    // this.map.setLayoutProperty("sessions", "visibility", this.state.cluster ? "visible" : "none");
    this.map.setLayerZoomRange("sessions", "minzoom", this.state.cluster ? 17 : 1, 11);
    this.setState({cluster: !this.state.cluster,})
  }

  // -------------------------------------
  // Viewport Functions
  // -------------------------------------


  _onMapMove = () => {
    const bounds = this.map.getBounds();
    let visibleSessions = this.map.queryRenderedFeatures({layers:['sessions']});
    // let visibleLines = this.map.queryRenderedFeatures({layers:['lines']});
    // console.log('f',features);
    visibleSessions = _.uniqBy(visibleSessions, 'properties.id');
    // visibleLines = _.uniqBy(visibleLines, 'properties.id');
    this.setState({
      visibleSessions,
      // visibleLines
    });

  }
  _resize = () => {
    this.setState({
      viewport: {
        ...this.state.viewport,
        width: window.innerWidth - MARGIN_LEFT,
        height: window.innerHeight
      }
    });
  };
  _onViewportChange = viewport => {
    this.setState({viewport: {...this.state.viewport, ...viewport}});
  }

  _moveTo = (lngLat, zoomTo) => {
    this._onViewportChange({
      longitude: lngLat[0],
      latitude: lngLat[1],
      zoom: zoomTo || this.state.viewport.zoom,
    });
  };

  _flyTo = (lngLat, zoomTo, duration, callback) => {
    this._onViewportChange({
      longitude: lngLat[0],
      latitude: lngLat[1],
      zoom: zoomTo || this.state.viewport.zoom,
      transitionInterpolator: new FlyToInterpolator(),
      transitionDuration: duration,
      transitionEasing: d3.easeCubicIn,
      onTransitionEnd: callback
    });
  };

  _flyToUserSessions = (lngLat, zoomTo, duration, callback) => {

    const { selectedUser } = this.state;
    if(selectedUser.sessions.length < 2) { return; }
    const coordinates = _.map(selectedUser.sessions, s => s.geometry.coordinates)
    console.log('coords',coordinates)

    const {longitude, latitude, zoom} = new WebMercatorViewport(this.state.viewport)
            .fitBounds(coordinates, {
              padding: 20,
              offset: [0, -100]
            });
        const viewport = {
            ...this.state.viewport,
            longitude,
            latitude,
            zoom,
            transitionDuration: 5000,
            transitionInterpolator: new FlyToInterpolator(),
            transitionEasing: d3.easeCubic
        }
        this.setState({viewport});


  };

  // -------------------------------------
  // Map Interaction Functions
  // -------------------------------------

  _onMapHover = event => {
    // console.log(event)
  }

  _clusterClicked = (features) => {
    // console.log('features',features[0])
    this._flyTo(features[0].geometry.coordinates, this.state.viewport.zoom + 1, 300,);
    return;
  }
  _linesClicked = (features) => {
    console.log('f',features);
  }

  _onMapClick = event => {
    console.log('clicked',event.features);
    const clusterClicked = _.filter(event.features,f=>f.layer.id ==='clusters');


    if(_.filter(event.features,f=>f.layer.id ==='clusters').length > 0)
      return this._clusterClicked(event.features);

    if(_.filter(event.features,f=>f.layer.id ==='lines').length > 0)
      return this._linesClicked(event.features);

    return;
    const linesClicked = _.filter(event.features,f=>f.layer.type ==='line');
    const sessionsClicked = _.filter(event.features,f=>f.layer.type ==='circle');
    const featuresNearby = event.features.length;
    const currentZoom = this.state.viewport.zoom;
    let newZoom = currentZoom;
    let duration = 200;
    let coordinates = event.lngLat;

    if(linesClicked.length > 0) {
      console.log('lines in the mix',linesClicked);
      return
    }

    //
    if(featuresNearby === 0) {
      // random map click
      console.log('nearby',featuresNearby)
      return;
    }
    else if(featuresNearby === 1) {
      // user clicked a single feature
      if(event.features[0].type === 'line') {
        // console.log('line was clicked',event.features[0])
        this.setState({selectedLine: event.features[0]});
        return;
      }
      newZoom = 11;
      this._setSelectedUser(event.features[0].properties);
      this.setState({activeFeatureId: event.features[0].properties.id});
      coordinates = event.features[0].geometry.coordinates;
      duration = 1600;
    } else if(featuresNearby > 1 && currentZoom < 4) {
      // user clicked area with many drawings from far away
      newZoom = 11.1;
      duration = 1600;
    } else if(featuresNearby > 1 && currentZoom >= 4) {
      // user clicked area with many drawings from sorta close
      newZoom = 11.1;
      duration = 1600;
    } else {
      console.log('how did i get here?')
    }

    this._flyTo(coordinates,newZoom, duration)
  }



  // -------------------------------------
  // Draw Lines Functions
  // -------------------------------------

  _testDraw = (sessionFeature) => {
    this._selectSession(sessionFeature);
    this._moveTo(sessionFeature.geometry.coordinates,14)
    this._drawLines(sessionFeature);
    console.log('su',this.state.selectedUser)
    _.forEach(this.state.selectedUser.sessions,this._drawLines)
  }

  _drawLines = (session) => {
    const sessionKey = session.properties.id;
    const alreadyRendered = this.state.renderedSessions.includes(sessionKey)
    // console.log('ar?',alreadyRendered)
    if(!alreadyRendered) {
      // console.log('lets render',this.state.renderedSessions);
      this.setState({renderedSessions: [...this.state.renderedSessions, sessionKey]})
      getLineFeaturesFromSession(session,this.props.firebase)
      .then(lineFeatures => {
      // console.log('lineFeatures',lineFeatures)
      this._addLineFeaturesToMap(lineFeatures);
      })

    } else {
      console.log('we already rendered this session',this.state.renderedSessions);
      return;
    }

  }

  _addLineFeaturesToMap = (lineFeatures) => {
    // console.log('me?',lineFeatures)
    var mapStyle = this.state.mapStyle
      .updateIn(['sources', 'drawings', 'data', 'features'], features => features.concat(lineFeatures));

    this.setState({
      mapStyle,
    });
  }

  // -------------------------------------
  // UI Functions
  // -------------------------------------

  _onSessionClickFromList = (session) => {

    if(this.state.activeFeatureId === session.properties.id) {
      this.setState({activeFeatureId: null});
      this._clearSelectedUser();
    } else {
      this.setState({activeFeatureId: session.properties.id});
      const newZoom = this.state.viewport.zoom > 12 ? this.state.viewport.zoom : 12;
      this._moveTo(session.geometry.coordinates, newZoom, 1500, () => this._selectSession(session) );
      this._selectSession(session)
    }
  }

  _onSessionHover = (session) => {
    // this._flyTo(session.geometry.coordinates,false,200)
  }

  _onSessionClickFromUser = (session) => {
    if(this.state.activeFeatureId === session.properties.id) {
      window.open(`/edit/${session.properties.id}`);
    } else {
      this.setState({activeFeatureId: session.properties.id});
      const newZoom = this.state.viewport.zoom > 11 ? this.state.viewport.zoom : 11;
      this._flyTo(session.geometry.coordinates, newZoom, 1500 );
    }
    this._drawLines(session);
  }

  _zoomOut = () => {
    // this._clearSelectedUser();
    // const newZoom = this.state.viewport.zoom - 5;
    this._onViewportChange({
      zoom: this.state.viewport.zoom - 5,
      transitionInterpolator: new FlyToInterpolator(),
      transitionDuration: 400
    });
  }

  _clearSelectedUser = () => {
    // console.log('me???')
    const { mapStyle } = this.state;
    // const newMapStyle = mapStyle
    //   .updateIn(['sources', 'selected-sessions', 'data', 'features'], features => []);

    this.setState({selectedUser: null, mapStyle: mapStyle});

    this.map.setPaintProperty("lines", "line-opacity", 1.0);

    this.map.setPaintProperty("lines", "line-width", 4);

  }

  _setLinesAsUnSelected = () => {
    this.map.setPaintProperty("lines", "line-opacity", 0.8);
    this.map.setPaintProperty("lines", "line-width", 2);
    this.map.setPaintProperty("lines", "line-blur", 2);
  }

  _selectSession = (session) => {
    // console.log('select session',session)
    // this._setLinesAsUnSelected()
    this.setState({
      selectedUser: this._getSelectedUser(session),
      activeFeatureId: session.properties.id, // this may already be set
    });
  }

  _getSelectedUser = ({properties}) => {
    const sessions = _.pickBy(this.state.sessions,s => s.properties.userId === properties.userId);
    _.forEach(sessions,this._drawLines)
    return {
      username: properties.username,
      userId: properties.userId,
      sessions,
    };

  }

  _setSelectedUser = (properties) => {
    const { sessions, mapStyle } = this.state;
    const userSessions = _.pickBy(sessions,s => s.userId === properties.userId);
    const selectedUser = {
      username: properties.username,
      userId: properties.userId,
      sessions: userSessions,
    };




    this.setState({
      selectedUser,
      // loadingUserSessions: true,
    });

    return;

  }


  _selectSessions = (sessions) => {

    // now try and add it to the layer
    const newSourceFeatures = getFeaturesFromGeoFire(sessions);

    // console.log('me???????',sessions)

    const mapStyle = this.state.mapStyle
      .updateIn(['sources', 'selected-sessions', 'data', 'features'], features => newSourceFeatures);

    this.setState({ mapStyle});

  }

  _renderLines = () => {
    const { features, renderedSessions } = this.state; // visible sessions
    const sessionsCouldRender = _.difference(features, renderedSessions );

    _.forEach(sessionsCouldRender, session => {
      this._addSessionToMapByKey(session.properties.id);
    })

  }

  render() {
    if(!this.props.isAdmin) { return null; }
    const {viewport, mapStyle, loading} = this.state;
    if(loading) { return <Loader active /> }

    // console.log(this.props)
    // console.log(this.state)

    return (
      <div>
      <MapGL
        ref={(el) => this.mapRef = el}
        {...viewport}
        mapStyle={mapStyle}
        onViewportChange={this._onViewportChange}
        mapboxApiAccessToken={this.props.MAPBOX_TOKEN}
        onHover={this._onMapHover}
        onClick={this._onMapClick}
        onLoad={this._onMapLoad}
        style={{marginLeft:MARGIN_LEFT}}
        >


      </MapGL>



      <UserProfile flyToUserSessions={this._flyToUserSessions} onSessionClick={this._onSessionClickFromUser} {...this.state} firebase={this.props.firebase}/>
      <Buttons onViewportChange={this._onViewportChange} {...this.state} />



      <SideBar
        onSessionClickFromList={this._onSessionClickFromList}
        toggleClusterSetting={this._toggleClusterSetting}
        onSessionHover={this._onSessionHover}
        selectUser={this._selectSession}
        {...this.state} />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/v3/Map.js